/** Dropdown menu placement: 8px gap from the trigger, 12px gutter to the viewport edges. */
export const MENU_GAP = 8;
export const MENU_GUTTER = 12;
export const MENU_MIN_WIDTH = 160;

export interface MenuPosition {
  left: number;
  top: number;
  width: number;
}

/**
 * Anchor a dropdown menu in the viewport (fixed positioning): prefer below the
 * trigger, flip above when there isn't room, clamp both axes so the whole menu
 * stays on screen. Mirrors the TimeSelect / RangeCalendar popover placement.
 */
export function computeMenuPosition(
  trigger: DOMRect,
  menuHeight: number,
  viewport: { width: number; height: number },
): MenuPosition {
  const width = Math.min(Math.max(trigger.width, MENU_MIN_WIDTH), viewport.width - MENU_GUTTER * 2);
  let left = trigger.left;
  if (left + width > viewport.width - MENU_GUTTER) left = trigger.right - width;
  left = Math.max(MENU_GUTTER, left);
  let top = trigger.bottom + MENU_GAP;
  if (top + menuHeight > viewport.height - MENU_GUTTER) top = trigger.top - MENU_GAP - menuHeight;
  top = Math.max(MENU_GUTTER, top);
  return { left, top, width };
}
